import { PlaneView } from '../../../../view/views/PlaneView';
import { SvgCursor } from './SvgCursor';

export enum PalmCursorMode {
    DEFAULT = 'default',
    GRAB = 'grab',
}

export class PalmCursor extends SvgCursor {
    protected _mode: PalmCursorMode;

    constructor(views: PlaneView[] | null) {
        super(views);
        this._mode = PalmCursorMode.DEFAULT;
        this.setCustomCursor();
    }

    public setMode(mode: PalmCursorMode) {
        this._mode = mode;
        this.setCustomCursor();
    }

    protected getSvgString(): string {
        if (this._mode === PalmCursorMode.GRAB) {
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M18 11.5V9a2 2 0 0 0-2-2 2 2 0 0 0-2 2v1.4M14 10V8a2 2 0 0 0-2-2 2 2 0 0 0-2 2v2M10 9.9V9a2 2 0 0 0-2-2 2 2 0 0 0-2 2v5M6 14a2 2 0 0 0-2-2 2 2 0 0 0-2 2"/><path d="M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0"/></svg>
            `;
        }
        return `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M18 11V6a2 2 0 0 0-2-2 2 2 0 0 0-2 2M14 10V4a2 2 0 0 0-2-2 2 2 0 0 0-2 2v2M10 10.5V6a2 2 0 0 0-2-2 2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>
            `;
    }

    protected getFallbackCursor(): string {
        return 'grab';
    }
}
